import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import type { User } from '@/interfaces';

import * as styles from './CompanyUsersTable.css';

type CompanyUsersTableProps = {
  columns: any[];
  data: User[];
  isLoading: boolean;
  isRefetching: boolean;
};

export default function CompanyUsersTable({ columns, data, isLoading, isRefetching }: CompanyUsersTableProps) {
  const { t } = useTranslation();

  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        <TradingDatagrid
          tableHeight="calc(50vh - 200px)"
          columnsTable={columns}
          dataTable={data}
          flexLayout
          keepSelectedRowsOnPageChange={false}
          columnOrder={[]}
          stickyColumns={{
            name: 'left',
            edit: 'right',
            delete: 'right',
          }}
          isLoadingMore={isRefetching || isLoading}
          noDataMessage={isRefetching || isLoading ? '' : t('settings.companyDetailsTab.companyUsers.emptyMessage')}
        />
      </div>
    </TradingPanel>
  );
}
